export const createMarketingBridge = (consent, loadAdjust) => ({
  async trackEvent(eventToken, payload) {
    if (!consent?.canUse('marketing')) return

    const Adjust = await loadAdjust?.()
    if (!Adjust || typeof Adjust.trackEvent !== 'function') return

    Adjust.trackEvent({
      eventToken,
      ...payload,
    })
  },
})
